import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUpdateCompanyGroup } from "./learningAPI";
import swal from 'sweetalert';
export interface UpdateCompanyGroupState {
  updateCompanyGroup: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: UpdateCompanyGroupState = {
    updateCompanyGroup: [],
  status: "idle",
};

export const GetUpdateCompanyGroup = createAsyncThunk(
  "UpdateCompanyGroup/fetchUpdateCompanyGroup",
  async (data:any) => {
    const response = await fetchUpdateCompanyGroup(data);
    return response;
  }
);

export const UpdateCompanyGroupSlice = createSlice({
  name: "UpdateCompanyGroup",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUpdateCompanyGroup.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUpdateCompanyGroup.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUpdateCompanyGroup.fulfilled, (state, action) => {
        state.status = "idle";
        state.updateCompanyGroup = action.payload;
        swal("Record updated success!",  "success");
      });
  },
});

export const {} = UpdateCompanyGroupSlice.actions;

export const selectUpdateCompanyGroup = (state: RootState) => {
  return state.UpdateCompanyGroup.updateCompanyGroup;
};

export default UpdateCompanyGroupSlice.reducer;
